import { render, staticRenderFns } from "./Colorbar.vue?vue&type=template&id=0dcbcfa8&scoped=true&"
import script from "./Colorbar.vue?vue&type=script&lang=js&"
export * from "./Colorbar.vue?vue&type=script&lang=js&"
import style0 from "./Colorbar.vue?vue&type=style&index=0&id=0dcbcfa8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcbcfa8",
  null
  
)

export default component.exports